{
  "name": "services-platform",
  "version": "2.23.0",
  "license": "MIT",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build:dev": "ng build --configuration=development",
    "build:stg": "ng build --configuration=staging",
    "build:pro": "ng build --configuration=production",
    "test": "ng test",
    "format": "npm run lint:fix && npm run pretty:fix",
    "lint": "npm run lint:quiet && npm run pretty:quiet",
    "lint:quiet": "npx eslint . --ext js,json,ts,html --quiet",
    "lint:fix": "npx eslint . --ext js,json,ts,html --fix",
    "pretty:quiet": "npx prettier . --check **/*.{js,ts,html,scss,css}",
    "pretty:fix": "npx prettier . --write **/*.{js,ts,html,scss,css}",
    "prepare": "npx husky",
    "check:livekit": "node scripts/check-livekit-version.mjs"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "18.2.3",
    "@angular/cdk": "^18.2.3",
    "@angular/common": "18.2.3",
    "@angular/compiler": "18.2.3",
    "@angular/core": "18.2.3",
    "@angular/forms": "18.2.3",
    "@angular/material": "^18.2.3",
    "@angular/platform-browser": "18.2.3",
    "@angular/platform-browser-dynamic": "18.2.3",
    "@angular/router": "18.2.3",
    "@contentful/rich-text-html-renderer": "12.0.0",
    "@gamelearn/gl-style-dictionary": "^0.10.0",
    "@gamelearn/skeletor": "^2.1.0",
    "@livekit/protocol": "1.44.0",
    "@mdi/font": "^7.4.47",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "@sentry/angular": "^8.29.0",
    "@stripe/stripe-js": "~4.4.0",
    "@webcomponents/webcomponentsjs": "^2.8.0",
    "contentful": "~11.0.3",
    "core-js": "^3.8.3",
    "livekit-client": "2.20.0",
    "moment": "^2.30.1",
    "moment-timezone": "^0.5.46",
    "ng-recaptcha-2": "^14.0.0",
    "ngx-toastr": "^19.0.0",
    "rxjs": "^7.8.1",
    "tslib": "^2.3.1",
    "zone.js": "~0.14.10"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.2.3",
    "@angular/cli": "18.2.3",
    "@angular/compiler-cli": "18.2.3",
    "@angular/language-service": "18.2.3",
    "@babel/eslint-parser": "^7.25.1",
    "@gamelearn/version": "^2.0.12",
    "@types/jasmine": "~5.1.4",
    "@types/node": "^22.5.4",
    "@typescript-eslint/eslint-plugin": "^5.62.0",
    "@typescript-eslint/parser": "^5.62.0",
    "eslint": "^8.57.1",
    "eslint-config-prettier": "^9.1.0",
    "eslint-import-resolver-typescript": "^2.7.1",
    "eslint-plugin-html": "^8.1.2",
    "eslint-plugin-import": "^2.30.0",
    "eslint-plugin-jasmine": "^4.2.2",
    "eslint-plugin-json-format": "^2.0.1",
    "eslint-plugin-prettier": "^4.2.1",
    "husky": "^9.1.6",
    "jasmine-core": "~5.3.0",
    "jasmine-spec-reporter": "~7.0.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "lint-staged": "^15.2.10",
    "prettier": "^2.8.8",
    "ts-node": "^10.9.2",
    "typescript": "5.5.4"
  },
  "engines": {
    "node": ">=20.11.1",
    "npm": ">=10.2.3"
  }
}
